import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IMealPlanExpertResponse, IMealPlanResponse} from '../../models/meal-plans';

@Component({
  selector: 'app-card-meal-plans',
  templateUrl: './card-meal-plans.component.html',
  styleUrls: ['./card-meal-plans.component.scss']
})
export class CardMealPlansComponent implements OnInit {
  Math = Math;

  @Input() mealPlan: IMealPlanResponse;
  @Input() cardToAssign: boolean;
  @Output() delete: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() edit: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() clone: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() assign: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
  ) { }

  ngOnInit(): void {
  }

  /**
   * Emite al componente padre cuando se quiere editar un plan de alimentación
   */
  onEmitEdit(): void {
    this.edit.emit(true);
  }

  /**
   * Emite al componente padre cuando se quiere clonar un plan de alimentación
   */
  onEmitClone(): void {
    this.clone.emit(true);
  }

  /**
   * Emite al componente padre cuando se quiere eliminar un plan de alimentación
   */
  onEmitDelete(): void {
    this.delete.emit(true);
  }

  /**
   * Emite al componente cuando se quiere asignar este plan alimenticio
   */
  onEmitAssignTo(): void {
    this.assign.emit(true);
  }

  get getAuthorMealPlanName(): string {
    const {name, lastname} = (this.mealPlan.expert as {user: IMealPlanExpertResponse})?.user ? (this.mealPlan.expert as {user: IMealPlanExpertResponse})?.user : (this.mealPlan.expert as IMealPlanExpertResponse);
    return `${name} ${lastname}`;
  }
}
